<template>
  <div>
    <section v-if="youtubeId" class="my-4">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + youtubeId" frameborder="0" allowfullscreen></iframe>
      </div>
    </section>
    <div v-if="steps.length" v-loading="loading">
      <div v-for="step in steps" :key="step.id" class="row mb-4">
        <div class="col-12 col-lg-6">
          <recipe-item-step-image :recipeId="recipeId" :step="step" />
        </div>
        <div class="col-12 col-lg-6">
          <h3>{{ step.sort }}</h3>
          <p>{{ step.content }}</p>
          <recipe-item-step-edit :recipeId="recipeId" :step="step" @update="getSteps" />
          <recipe-item-step-delete :recipeId="recipeId" :stepId="step.id" @delete="getSteps" />
        </div>
        <div class="col-12">
          <recipe-item-ingredient :recipeId="recipeId" :stepId="step.id" :recipeIngredients="step.ingredients" :legacyIngredients="legacyIngredients" @update="getSteps" />
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <p>No recipe steps were found.</p>
    </div>
    <section class="my-4">
      <recipe-item-step-create :recipeId="recipeId" @create="getSteps" />
    </section>
  </div>
</template>

<script>
import RecipeItemStepCreate from '@/components/Recipe/Item/RecipeItemStepCreate'
import RecipeItemStepEdit from '@/components/Recipe/Item/RecipeItemStepEdit'
import RecipeItemStepDelete from '@/components/Recipe/Item/RecipeItemStepDelete'
import RecipeItemStepImage from '@/components/Recipe/Item/RecipeItemStepImage'
import RecipeItemIngredient from '@/components/Recipe/Item/RecipeItemIngredient'

export default {
  components: {
    RecipeItemStepCreate,
    RecipeItemStepEdit,
    RecipeItemStepDelete,
    RecipeItemStepImage,
    RecipeItemIngredient,
  },

  props: {
    recipeId: String,
    youtubeId: String,
    recipeSteps: Array,
    legacyIngredients: Array,
  },

  data() {
    return {
      loading: false,
      steps: this.recipeSteps,
    }
  },

  methods: {
    async getSteps() {
      this.loading = true
      this.steps = []

      try {
        var { data } = await this.$http.get(`/recipes/${ this.recipeId }/steps`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.steps = data
    },
  },
}
</script>
